// src/components/AuthProviderWithRef.tsx
import React, { useContext, ReactNode, ReactElement } from 'react';
import { AuthProvider, AuthContext, AuthProviderProps } from 'react-oidc-context';
import { setAuthContext } from '../authContextRef';
import { useNavigate } from 'react-router-dom';


// Define our own props instead of extending AuthProviderProps
interface AuthProviderWithRefProps {
    children: ReactNode;
    // Add the OIDC settings properties
    // authority?: string;
    // client_id?: string;
    // redirect_uri?: string;
    [key: string]: any; // Allow any other properties from UserManagerSettings
  }
  
  export function AuthProviderWithRef({ children, ...props }: AuthProviderWithRefProps): ReactElement {
    return (
      <AuthProvider {...props}>
        <AuthContextCapture />
        {children}
      </AuthProvider>
    );
  }
  
  // Component that captures the context value without useEffect
  function AuthContextCapture(): null {
    //navigateRef = useNavigate()
    const auth = useContext(AuthContext);
    
    // Set the global ref directly during render
    if( !!auth) {
        setAuthContext(auth);
    }
    
    return null;
  }


//   export function RouterContextSetup(): null {
//   // 1. This hook is valid because it will be rendered as a child of RouterProvider
//   const navigate = useNavigate(); 
  
//   // 2. Set the global reference immediately
//   navigateRef = navigate;
  
//   // This component's only job is the side effect; it renders nothing
//   return null; 
// }